import { Camera, Scene, Vector3 } from "three";
import { DeviceOrientationControls } from "three/examples/jsm/controls/DeviceOrientationControls";
import CurrentPlayer from "../Player/CurrentPlayer";
import PlayerPhysics from "../Player/PlayerPhysics";
import UserControls, { getYLockedRotation } from "./UserControls";
import { IMovement } from "./Movement";

class UserControlsOrientation implements UserControls {
    public scene: Scene;

    public gameObject: CurrentPlayer;

    public physics: PlayerPhysics;

    public controls: DeviceOrientationControls;

    public jumpPower: number;

    public moveSpeed: number;

    public movement: IMovement;

    public canJump: boolean;

    constructor(
        camera: Camera,
        scene: Scene,
        gameObject: CurrentPlayer,
        physics: PlayerPhysics
    ) {
        this.scene = scene;
        this.gameObject = gameObject;
        this.physics = physics;
        this.controls = new DeviceOrientationControls(camera);
        this.jumpPower = 6;
        this.moveSpeed = 12;
        this.movement = {
            down: false,
            jump: false,
            left: false,
            right: false,
            up: false,
        };
        this.canJump = false;
        this.initialiseControls();
    }

    public initialiseControls(): void {
        const { scene, controls, movement } = this;
        controls.connect();
        controls.update();

        controls.object.position.set(0, 30, 0);
        scene.add(controls.object);
        movement.up = true;
    }

    public update(delta: number): void {
        const {
            controls,
            moveSpeed,
            movement,
            jumpPower,
            gameObject,
            physics,
        } = this;
        this.controls.update();

        const camera = controls.object;

        camera.position.set(
            gameObject.position.x,
            gameObject.position.y,
            gameObject.position.z
        );

        const direction = new Vector3(
            Number(movement.right) - Number(movement.left),
            0,
            Number(movement.down) - Number(movement.up)
        );

        direction.applyQuaternion(camera.quaternion);
        direction.normalize();

        if (movement.up || movement.down || movement.left || movement.right) {
            this.gameObject.velocity.z += direction.z * delta * moveSpeed;
            gameObject.velocity.x += direction.x * delta * moveSpeed;
        }
        if (movement.jump && physics.onGround) {
            gameObject.velocity.y += jumpPower;
            physics.onGround = false;
        }

        // Update player rotation from controls, since the controls define the player not the other way around
        if (gameObject.model) {
            const gottenRotation = getYLockedRotation(gameObject.model, camera);
            gameObject.rotation.set(
                gottenRotation.x,
                gottenRotation.y,
                gottenRotation.z
            );
        }
    }

    // eslint-disable-next-line
    public lock() {}
}

export default UserControlsOrientation;
